// removed by extract-text-webpack-plugin
module.exports = {"container":"_2xCpb","container-left":"_4X-fs","container-right":"_1U1pg","speech-bubble-left":"_177es","speech-bubble-right":"_3EQrS","avatar-reverse-display":"_23glO","avatar-container":"_1256t","avatar":"_2sOzQ","quote":"_3lsSX","name":"_3xtPa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Testimonial.less
// module id = ./src/components/Home/Testimonial.less
// module chunks = 2